import API from '@/api/api'

const defaultData = {
  order     : 'votes', // name, url, homepage, favicon, tags, country, state, language, votes, codec, bitrate, lastcheckok, lastchecktime, clicktimestamp, clickcount, clicktrend, changetimestamp, random
  reverse   : true,
  offset    : 0,
  limit     : 10_000,
  hidebroken: true
}

export default {
  async getByCountry (country, data = {}, config = {}) {
    const endpoint = API.endpointConfig.radio.getByCountry
    endpoint.path = endpoint.path.replace('{country}', country || '')

    const payload = { ...defaultData, ...data }
    const configuration = { ...config }
    return await API.restRequest(endpoint, payload, configuration)
  },

  async getByLanguage (language, data = {}, config = {}) {
    const endpoint = API.endpointConfig.radio.getByLanguage
    endpoint.path = endpoint.path.replace('{language}', language || '')

    const payload = { ...defaultData, ...data }
    const configuration = { ...config }
    return await API.restRequest(endpoint, payload, configuration)
  },

  async getByTag (tag, data = {}, config = {}) {
    const endpoint = API.endpointConfig.radio.getByTag
    endpoint.path = endpoint.path.replace('{tag}', tag || '')

    const payload = { ...defaultData, ...data }
    const configuration = { ...config }
    return await API.restRequest(endpoint, payload, configuration)
  }
}
